/** @returns {InterviewClientState} */
export function initInterviewClientState(state = {}) {
    return {
        ...(state || {}),

        stream: state?.stream || null,
        stream_media: state?.stream_media || null,

        enabled_audio: undefined,
        enabled_video: undefined,
        enabled_muted: false,
    };
}

/**
 * @typedef InterviewClientState
 *
 * @property {MediaStream|null} stream 후처리 스트림
 * @property {MediaStream|null} stream_media 미디어 스트림
 *
 * @property {boolean} enabled_audio 오디오 활성화
 * @property {boolean} enabled_video 비디오 활성화
 * @property {boolean} enabled_muted 음소거 활성화
 */
